<template>
    <!-- 升学途径分析 -->
  <div>
    <div class="test_question" v-if="question_data">
    	<div class="question" v-for="(item, index) in question_data" :key="index" :id="'question' + item.id">
            <p class="title"><b>*</b>{{item.topic}}</p> 
            <p v-show="item.details" class="remarks"><b>*</b>备注：{{item.details}}</p>
            <div class="option_box" v-if="item.type == 1"> 
                <el-radio-group v-model="answered[item.id].judgeAnswer">
                    <el-radio :label="option" v-for="(option,index) in item.options" :key="index">{{option.optTxt}}</el-radio>
                </el-radio-group>
            </div>
            <div class="option_box" v-if="item.type == 2&& item.id==4"> 
                <el-date-picker
                      v-model="answered[item.id].judgeAnswer"
                      type="date"
                      placeholder=""
                      value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div class="input_box" v-if="item.type == 5&&item.id==7"> 
                <!-- <el-input v-model="answered[item.id].judgeAnswer" placeholder="" type="number"></el-input> -->
                <el-select v-model="answered[item.id].judgeAnswer"  placeholder="">
                    <el-option v-for="(item, $index) in weights" :key="$index" :label="item" :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="input_box" v-if="item.type == 5&&item.id==6 "> 
                <el-select v-model="answered[item.id].judgeAnswer"  placeholder="">
                    <el-option v-for="(item, $index) in heights" :key="$index" :label="item" :value="item">
                    </el-option>
                </el-select>
            </div>            
            <div class="option_box" v-if="item.type == 3"> 
                <el-select v-model="answered[item.id].judgeAnswer"  placeholder="">
                    <el-option v-for="(option,index) in item.options" :key="index" :label="option.optTxt" :value="option.optTxt">
                    </el-option>
                </el-select>
            </div>
            <div class="option_box" v-if="item.type == 4"> 
                <el-select v-model="answered[item.id].judgeAnswer"  placeholder="">
                    <el-option v-for="(item, $index) in years" :key="$index" :label="item" :value="item">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="btn_box">
            <div class="box">
                <div class="btn_pre btn"  @click="changeQuestionPrev(question_index)" v-show="prev">上一步</div>
                <div class="btn_next btn" @click="changeQuestionNext(question_index)" v-show="next" :class="isFinish == true ? '' : 'unactive'" >下一步</div>
                <button class="btn_next btn" @click="goStoreResult()" :disabled="isDisable" v-show="submit" :class="isFinish == true ? '' : 'unactive'">提交</button>
            </div>    
        </div>
    </div>
  </div>
</template>
<script>
export default {
    components: { },
    data() {
        return {
            isDisable: false,
            isFinish:true,
            question: [],
            years: [],
            heights:[],
            weights:[],
            question_all_data: null,  //全部题目
            question_data: [], //展示的题目
            answered: null,  
            question_index:0,  // 默认展示第一道题，后边++ -- 
            prev:false,  //上一步
            next:true ,// 下一步
            submit:false, //提交
            answered_arr:[],
            ten:true,
            twenty_two:true,
            twenty_three:true,
            success_data:false,
            gaokao_year:'',
            is_minority:'',
            is_poor_house:'',
            birthday:'',
            sex:'',
            weight:'',
            is_vision_surgery:'',
            eye_vision:'',
            eyeglass_degrees:'',
            is_color_blindness:'',
            is_stutter:'',
            is_lang_en:'',
            gaokao_line:'',
            is_award:'',
            is_orsay_member:'',
            is_en_middle_school:'',
            is_heroes_children:'',
            is_retired_athletes:'',
            is_have_art:'',
            is_have_sports:'',
            is_get_sports:'',
            is_get_match:'',
            is_family_affluent:'',
        }
    },
    methods: {
        // 获取测试题
        getTopicAndOptionsList() {
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken')||window.localStorage.getItem('localtoken');
            this.$ajax
                .post(this.G_testuri + '/topic/getQuestion', {
                },{
                    headers:{
                        token: token
                    }
                })              
                // 监听数据返回
                .then(function(res) {                           
                    _this.question_all_data = res.data.data;
                    _this.question_data.push(_this.question_all_data[_this.question_index])                            	
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        // 减--返回上一题
        changeQuestionPrev(question_index){           
            if(question_index<=23){
                this.next = true
                this.submit = false
            }
           if(question_index == 10 && this.ten == false){
               this.question_index = Number(question_index - 2);
               this.question_data = []
               this.question_data.push(this.question_all_data[this.question_index])
           }else if(question_index == 23 && this.twenty_two == false && this.twenty_three == false){
               this.question_index = Number(question_index - 3);
               this.question_data = []
               this.question_data.push(this.question_all_data[this.question_index]);
           }else if(question_index == 23 && this.twenty_two == true && this.twenty_three == false){
               this.question_index = Number(question_index - 2);
               this.question_data = []
               this.question_data.push(this.question_all_data[this.question_index]);
           }else{
                if(question_index == 1){
                    this.prev = false;
                    this.question_index = 0
                    this.question_data = []
                    this.question_data.push(this.question_all_data[this.question_index]);
                    return false
                }else{
                    this.question_index = Number(question_index - 1);
                    this.question_data = []
                    this.question_data.push(this.question_all_data[this.question_index]);
                }               
           }                    
        },
        // 加--进行下一道题
        changeQuestionNext(question_index) {
            if(this.answered[question_index+1].judgeAnswer==''){
                this.$message({
                     message: '请选择',
                     type: 'warning'
                 });
                 return;
            }
            this.prev = true
            // 判断第九题选项是否展示第十题
            if(question_index == 8){
                for (var key in this.answered) {                    
                    if(key == 9){                       
                        if(this.answered[key].judgeAnswer == '4.9≤裸眼视力<5.0' || this.answered[key].judgeAnswer =='4.8≤裸眼视力<4.9' || this.answered[key].judgeAnswer=='4.9≤裸眼视力<5.0' || this.answered[key].judgeAnswer=='裸眼视力≥5.0' ){                         
                            this.question_index = Number(question_index + 2);
                            this.question_data = []
                            this.question_data.push(this.question_all_data[this.question_index])
                            this.ten = false // 第十题不显示
                        }else{
                            this.question_index = Number(question_index+1);
                            this.question_data = []
                            this.question_data.push(this.question_all_data[this.question_index])
                            this.ten = true
                        }
                    }                  
                } 
            }else if(question_index == 20){
                for (var key in this.answered) {                    
                    if(key == 21){                       
                        if(this.answered[key].judgeAnswer.optTxt == '否' ){                         
                            this.question_index = Number(question_index + 3);
                            this.question_data = []
                            this.question_data.push(this.question_all_data[this.question_index])
                            this.twenty_two=false
                            this.twenty_three=false
                            this.next = false
                            this.submit = true

                        }else{
                            this.question_index = Number(question_index+1);
                            this.question_data = []
                            this.question_data.push(this.question_all_data[this.question_index])
                            this.twenty_two=true
                            this.twenty_three=true
                        }
                    }
                } 
            }else if(question_index == 21){               
                for (var key in this.answered) {                                       
                    if(key == 22){                       
                        if(this.answered[key].judgeAnswer.optTxt == '否' ){                         
                            this.question_index = Number(question_index + 2);
                            this.question_data = []
                            this.question_data.push(this.question_all_data[this.question_index])
                            this.twenty_two=true
                            this.twenty_three=false
                            this.next = false
                            this.submit = true
                        }else{
                            this.question_index = Number(question_index+1);
                            this.question_data = []
                            this.question_data.push(this.question_all_data[this.question_index])                           
                            this.twenty_two=true
                            this.twenty_three=true                           
                        }
                    }                   
                } 
            }else{
                this.question_index = Number(question_index + 1);
                this.question_data = []
                this.question_data.push(this.question_all_data[this.question_index])
                if(question_index==22){
                    this.next = false
                    this.submit = true
                }
            }                          
        },
        // 提交测试结果  
        goStoreResult() {
            
            if(this.answered[24].judgeAnswer==''){
                this.$message({
                     message: '请选择',
                     type: 'warning'
                 });
                 return;
            }
            
            // var params = {}
            var _this = this;
            for(var key in this.answered){
                if(key==1){
                    this.gaokao_year = this.answered[1].judgeAnswer
                }else if(key==2){
                    this.is_minority = this.answered[2].judgeAnswer.optOrder
                }else if(key==3){
                    this.is_poor_house = this.answered[3].judgeAnswer.optOrder
                }else if(key==4){
                    this.birthday = this.answered[4].judgeAnswer
                }else if(key==5){
                    this.sex = this.answered[5].judgeAnswer.optOrder
                }else if(key==6){
                    this.height = this.answered[6].judgeAnswer=='150及150以下'?Number(150):this.answered[6].judgeAnswer=='200及200以上'?Number(200):Number(this.answered[6].judgeAnswer);
                }else if(key==7){
                    this.weight = this.answered[7].judgeAnswer=='30及30以下'?Number(30):this.answered[7].judgeAnswer=='100及100以上'?Number(100):Number(this.answered[7].judgeAnswer);
                }else if(key==8){
                    this.is_vision_surgery = this.answered[8].judgeAnswer.optOrder
                }else if(key==9){
                    this.eye_vision = this.answered[9].judgeAnswer=='裸眼视力<4.0'?1:this.answered[9].judgeAnswer=='4.0≤裸眼视力<4.5'?2:this.answered[9].judgeAnswer=='4.5≤裸眼视力<4.6'?3:this.answered[9].judgeAnswer=='4.6≤裸眼视力<4.7'?4:this.answered[9].judgeAnswer=='4.7≤裸眼视力<4.8'?5:this.answered[9].judgeAnswer=='4.8≤裸眼视力<4.9'?6:this.answered[9].judgeAnswer=='4.9≤裸眼视力<5.0'?7:this.answered[9].judgeAnswer=='裸眼视力≥5.0'?8:''
                }else if(key==10){
                    this.eyeglass_degrees = this.answered[10].judgeAnswer=='600度以下'?1:this.answered[10].judgeAnswer=='600度及以上'?2:''
                }else if(key==11){
                    this.is_color_blindness = this.answered[11].judgeAnswer.optOrder
                }else if(key==12){
                    this.is_stutter = this.answered[12].judgeAnswer.optOrder
                }else if(key==13){
                    this.is_lang_en = this.answered[13].judgeAnswer.optOrder
                }else if(key==14){
                    this.gaokao_line = this.answered[14].judgeAnswer=='一本批次或相应水平'?1:this.answered[14].judgeAnswer=='二本批次或相应水平'?2:this.answered[14].judgeAnswer=='其他'?3:''
                }else if(key==15){
                    this.is_award = this.answered[15].judgeAnswer.optOrder
                }else if(key==16){
                    this.is_orsay_member = this.answered[16].judgeAnswer.optOrder
                }else if(key==17){
                    this.is_en_middle_school = this.answered[17].judgeAnswer.optOrder
                }else if(key==18){
                    this.is_heroes_children = this.answered[18].judgeAnswer.optOrder
                }else if(key==19){
                    this.is_retired_athletes = this.answered[19].judgeAnswer.optOrder
                }else if(key==20){
                    this.is_have_art = this.answered[20].judgeAnswer.optOrder
                }else if(key==21){
                    this.is_have_sports = this.answered[21].judgeAnswer.optOrder
                }else if(key==22){
                    this.is_get_sports = this.answered[22].judgeAnswer.optOrder?this.answered[22].judgeAnswer.optOrder:''
                }else if(key==23){
                    this.is_get_match = this.answered[23].judgeAnswer.optOrder?this.answered[23].judgeAnswer.optOrder:''
                }else if(key==24){
                    this.is_family_affluent = this.answered[24].judgeAnswer.optOrder
                }
            }
            
            var token = window.sessionStorage.getItem('ymtxToken')||window.localStorage.getItem('localtoken');
            this.$ajax
                .post(this.G_testuri + '/result/setAnswer',{
                    gaokao_year:this.gaokao_year,
                    is_minority:this.is_minority,
                    is_poor_house:this.is_poor_house,
                    birthday:this.birthday,
                    sex:this.sex,
                    height:this.height,
                    weight:this.weight,
                    is_vision_surgery:this.is_vision_surgery,
                    eye_vision:this.eye_vision,
                    eyeglass_degrees:this.ten==true?this.eyeglass_degrees:'',
                    is_color_blindness:this.is_color_blindness,
                    is_stutter:this.is_stutter,
                    is_lang_en:this.is_lang_en,
                    gaokao_line:this.gaokao_line,
                    is_award:this.is_award,
                    is_orsay_member:this.is_orsay_member,
                    is_en_middle_school:this.is_en_middle_school,
                    is_heroes_children:this.is_heroes_children,
                    is_retired_athletes:this.is_retired_athletes,
                    is_have_art:this.is_have_art,
                    is_have_sports:this.is_have_sports,
                    is_get_sports:this.twenty_two==true?this.is_get_sports:'',
                    is_get_match:this.twenty_three==true?this.is_get_match:'',
                    is_family_affluent:this.is_family_affluent,                   
                },{
                    headers:{
                        token: token
                    }
                })              
                // 监听数据返回
                .then(function(res) {  
                    if(res.data.code == 2000)  {   
                        let url = '/testreport_mobile' 
                        let {href} = _this.$router.resolve({
                            path: url
                        })
                        window.open(href,'_self');
                    }else{
                        this.$message({
                            message: '请勿重复提交数据',
                            type: 'error'
                        });
                        return;
                    }                                            	
                })
                .catch(function(error) {
                    console.log(error)
                })   
                this.isDisable = true
                    setTimeout(() => {
                        _this.isDisable = false
                }, 10000)                 
        }, 
        getYear() {
            let date=new Date();           
            let year=date.getFullYear();

            if(date.getMonth()+1>7){
                year = year + 1;
                for (let i=0;i<4;i++){
                    this.years[i] = year++;
                }
            }else{
                for (let i=0;i<5;i++){
                    this.years[i] = year++;
                }
            }
            // for (let i=0;i<5;i++){
            //         this.years[i] = year++;
            //     }           
        }, 
        get_Height(){
            for(var i=151;i<200;i++){
                this.heights.push(i)
            }
            this.heights.unshift('150及150以下');
            this.heights.push('200及200以上');        
        },      
        get_Weight(){
            for(var i=31;i<100;i++){
                this.weights.push(i)
            }
            this.weights.unshift('30及30以下');
            this.weights.push('100及100以上');          
        }   
    },
    watch: {
        question_all_data() {   
            let question_object = {}
            let question_all_data = this.question_all_data;           
            question_all_data.forEach((item) => {
                let obj = {};
                obj.questionNum = item.id;
                obj.showAnswer = '';
                obj.judgeAnswer = '';
                question_object[item.id] = obj;
            })                     
            this.answered = question_object;                
        },            
    },
    computed:{},
    mounted() {},
    created() {
        this.getTopicAndOptionsList();
        this.getYear(); 
        this.get_Height();  
        this.get_Weight();   
    }
}
</script>
<style type="text/css" lang='less' scoped>
.box button{
    outline: none;
    border: none;
}
.test_question {
    .question {
        margin-bottom: 10px;
        .title {
            line-height: 38px;
            color: #333333;
            font-size: 16px; 
            b{
                color: #f00;
            }   
            a{
                color: #333333;
                font-size: 14px;
            }    
        }
        .remarks{
            color: #2c8ffc;
            font-size: 12px;
            margin:8px 0;
        }
        .option_box {
            overflow: hidden;
            .inputs {
                float: left;
                margin-right: 20px;
            }
        }
        .input_box {
            width: 200px;
        }
    }
    .btn_box {
        padding: 43px 0px;
        .box {
            width: 300px; 
            height: 36px;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            .btn {
                line-height: 36px;
                text-align: center;
                background-color: #2c8ffc;
                width: 100px;
                border-radius: 5px;
                color: #fff;
                margin: 0px 20px;
                cursor: pointer;
            }
            .unactive {
                background-color: #eaeaea;
            }
            .unSubmit{
                background-color: #eaeaea;
            }
        }
    }
    .fixd_box {
        width: 210px;
        height: 300px;
        position: fixed;
        bottom: 200px;
        right: 2px;
        z-index: 3;
        box-shadow: 0px 0px 10px #dedede; 
        background-color: #fff;
        .title {
            line-height: 50px;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
        }
        ul {
            width: 210px;
            display: flex;
            flex-wrap: wrap;
            li {    
                width: 30px;
                height: 30px;
                border-radius: 5px;
                text-align: center;
                line-height: 30px;
                margin-left: 10px;
                margin-bottom: 5px;
                color: #fff;
                cursor: pointer;
                
            }
            .finish {
                color: #fff;
                background-color: #2c8ffc;
            }
            .unfinish {
                color: #fff;
                background-color: #eaeaea;
            }
        }
        .btn {
            width: 30px;
            height: 50px;
            position: absolute;
            left: -30px;
            top: 50%;
            cursor: pointer;
            margin-top: -25px;
        }
        .slide {
            background: url(/imgs/wayToStudy/common/icon_youhua.png) no-repeat center center;
        }
        .unslide {
            background: url(/imgs/wayToStudy/common/icon_zuohua.png) no-repeat center center;
        }
    }
    .slide {
        right: 2px;
        transition: all 1s;
    }
    .unslide {
        right: -210px;
        transition: all 1s;
    }
}
</style>
<style type="text/css" lang='less'>
.test_question {
    .el-input__inner  {
        border: 1px solid #DCDFE6 !important;
        border-radius: 4px;
    }
    .el-radio-group {
        .el-radio {
            display: block;
            line-height: 30px;
        }
    }
}
/deep/.el-scrollbar{
.el-scrollbar__bar{
    opacity: 1;//改为0不显示滚动条
//   width:5px;
}
}
/deep/.el-scrollbar__wrap{
    height: 100%;
    overflow-y: scroll;
}
</style>